import { crmSystem } from "@/constants/crm/_shared/systems";
import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { ConfigurationParametersInputProps as _ConfigurationParameterInputProps } from "@/features/crm_system/lib/crm/_common/ConfigurationParameterInput";

interface ConfigurationParameterInputProps extends _ConfigurationParameterInputProps {
    crmSystem: crmSystem | undefined | null;
}
export function ConfigurationParameterInput({crmSystem, values = [], onChange = () => {}, onEvent, ...props }:Readonly<ConfigurationParameterInputProps>) {
    const ConfigurationParameterInput = crmRegistry.getConfigurationParameterInput(crmSystem);
    return <ConfigurationParameterInput values={values} onChange={onChange} onEvent={onEvent} {...props}/>;
}